import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type components } from 'src/api/playerPayback/api'

export const useGetBadgeRewardById = ({
  badgeRewardId,
}: {
  badgeRewardId: number
  enabled?: boolean
}): UseQueryResult<components['schemas']['BadgeRewardDTO']> => {
  const get = useTypedApiClient({
    path: '/admin/badgerewards/{id}',
    method: 'get',
  })
  return useQuery({
    queryKey: ['/admin/badgerewards/{id}', badgeRewardId],
    queryFn: async () => {
      const { data } = await get({ id: badgeRewardId })
      return data
    },
  })
}
